module.exports = __webpack_public_path__ + "static/media/cat-transparent2.48970d7f.png";